<!-- 滑块卡片 -->
<template>
  <div
    class="card-swiper"
    :style="{
      '--card-width': `${cardWidth}px`,
      '--card-img-limit': cardImgLimit,
    }"
  >
    <div class="card-swiper__header" :class="`card-swiper__header--${moduleConfig.align}`">
      <p class="title_font card-swiper__title" v-if="moduleConfig.title">
        {{ moduleConfig.title }}
      </p>
      <!-- 评分 -->
      <div class="card-swiper__rating">
        <commentsstar :disabled="true" :average_rating="avgRating" :font_size="22" />
        <span class="card-swiper__text secondary_title" v-cloak> {{ data.length }} {{ $t('comment.reviews') }} </span>

        <div class="card-swiper__nav">
          <a @click="prev" :class="{ disabled: data.length < 2 || (width >= 768 && data.length === 2) }">
            <i class="el-icon-arrow-left" />
          </a>
          <a
            @click="next"
            :class="{
              disabled: data.length < 2 || (width >= 768 && data.length === 2),
            }"
          >
            <i class="el-icon-arrow-right" />
          </a>
        </div>
      </div>
    </div>

    <!-- 走马灯, 数量大于等于三个的时候, 移动端 -->
    <template v-if="data.length >= 3 || width < 768">
      <el-carousel
        ref="carousel"
        class="card-swiper__carousel"
        :type="width >= 768 ? 'card' : ''"
        :loop="loop"
        :initial-index="0"
        :autoplay="false"
        indicator-position="none"
        arrow="never"
        @change="handleChange"
      >
        <el-carousel-item class="card-swiper__item" v-for="(item, index) in data" :key="item.ID">
          <comment-card
            ref="commentCard"
            class="card-swiper__card"
            :data="item"
            :img-limit="cardImgLimit"
            @click="() => handleClick(index)"
            @loaded="() => handleloaded(index)"
          />
        </el-carousel-item>
      </el-carousel>
    </template>

    <!-- 两个及以下布局 -->
    <template v-else>
      <div class="card-swiper__row-2">
        <div class="card-swiper__col-2" v-for="(item, index) in data" :key="item.ID">
          <comment-card
            ref="commentCard"
            class="card-swiper__card"
            :img-limit="5"
            :data="item"
            @click="() => $emit('click', index)"
          />
        </div>
      </div>
    </template>
    <div class="card-swiper__btn-wrapper">
      <a
        v-if="customButtom.show && customButtom.text"
        class="home-btn secondary_title"
        :href="customButtom.url"
        :style="{
          '--btn-bg-color': moduleConfig.button_background_color,
          '--btn-color': moduleConfig.button_text_color,
        }"
      >
        {{ customButtom.text }}
      </a>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import CommentCard from './components/CommentCard.vue'
import Commentsstar from '@/js/components/view/comments/commentsstar.vue'

export default {
  name: 'CardSwiper',
  components: {
    CommentCard,
    Commentsstar,
  },
  props: {
    data: {
      type: Array,
      require: true,
    },
    // 平均值
    avgRating: {
      type: Number,
      default: 0,
    },
    // 配置
    moduleConfig: {
      type: Object,
      require: true,
    },
  },
  emits: ['click'],
  computed: {
    carousel() {
      return this.$refs.carousel
    },
    commentCard() {
      return this.$refs.commentCard
    },
    /**
     * 根据屏幕宽度，计算评论卡片最多显示图片
     * < 375px 4,
     * 375~768 5,
     * 768~920 4
     * 920~1440 5
     * > 1440 6
     *  */
    cardImgLimit() {
      // 开启宽屏
      if (this.moduleConfig?.wildscreen && this.width > 1440) return 6
      if (this.width > 920) return 5
      if (this.width > 768) return 4
      if (this.width > 375) return 5
      return 4
    },
  },
  data() {
    return {
      height: 0,
      activeIndex: 0,
      swiping: true, // 切换中,
      carouselType: null,
      width: document.body.offsetWidth,
      loop: true, // 开启循环
      // cardImgLimit: 5,
      customButtom: this.moduleConfig?.show_custom_button || {},
      cardWidth: 0,
    }
  },
  created() {
    /**
     * 改变页面大小
     * 引入反抖动
     * */
    this.handleResize = debounce(() => {
      const width = document.body.offsetWidth

      // 屏幕宽度
      this.width = width
      // 卡片宽度
      const cardWidth = this.commentCard?.[this.activeIndex]?.$el?.offsetWidth || 0
      this.cardWidth = cardWidth
    }, 200)
  },
  mounted() {
    // 增加宽度监听
    // 如果评论数大于两个的时候，需要根据屏幕大小修改细节
    if (this.data.length >= 2) {
      window.addEventListener('resize', this.handleResize)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    /**
     * 上一个
     */
    prev() {
      this.carousel?.prev()
    },
    /**
     * 下一个
     */
    next() {
      this.carousel?.next()
    },
    /**
     * 点击当前卡片
     */
    handleClick(index) {
      if (this.activeIndex === index) {
        this.$emit('click', index)
      }
    },
    /**
     * 走马灯切换
     * 移动端每次切换，需要重新计算下高度
     */
    handleChange(index, val) {
      this.activeIndex = index
      // 计算下当前的高度
      // this.swiping = true
      // setTimeout(() => {
      //   this.computedHeight(index)
      // }, 100)
    },
    /**
     * 计算高度
     * 计算前一张，后一张的高度
     * 取坐高高度
     * 移动端的时候，仅关心当前高度
     * 当前那弃用
     */
    computedHeight(index) {
      // pc 端
      if (this.width >= 768) {
        let preIndex = index - 1
        let nextIndex = index + 1

        // 开启循环的话
        if (this.loop) {
          if (index === 0) {
            // 最后一个即前一个
            preIndex = this.data?.length - 1
          }
          if (index === this.data?.length - 1) {
            nextIndex = 0
          }
        }
        const preDom = this.commentCard[preIndex]?.$el
        const currentDom = this.commentCard[index]?.$el
        const nextDom = this.commentCard[nextIndex]?.$el

        const preHeight = preDom?.offsetHeight || 0
        const currentHeight = currentDom?.offsetHeight || 0
        const nextHeight = nextDom?.offsetHeight || 0

        let height = preHeight
        if (currentHeight > height) {
          height = currentHeight
        }

        if (nextHeight > height) {
          height = nextHeight
        }
        this.height = height
      } else {
        const mobileCardDom = this.$refs?.commentMobildCard?.[index]?.$el
        const mobileCardHeight = mobileCardDom.offsetHeight || 0

        this.height = mobileCardHeight
      }
      this.swiping = false
    },
    /**
     * 加载结束
     */
    handleloaded(index) {
      const that = this
      // 计算下卡片的宽度
      if (index === 0) {
        setTimeout(() => {
          const cardWidth = that.$refs.commentCard?.[0]?.$el?.offsetWidth || 0
          that.cardWidth = cardWidth
        }, 100)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card-swiper {
  &__title {
    font-size: 24px;
    color: #333;
    line-height: 33px;
  }
  &__header {
    // 标题居左
    &--left {
      display: flex;
      align-items: center;
      .card-swiper {
        &__title {
          flex: 1;
        }
      }
    }
    // 标题居中
    &--center {
      text-align: center;
      .card-swiper {
        &__rating {
          margin-top: 16px;
          justify-content: center;
        }
      }
    }
  }
  &__rating {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    ::v-deep {
      .el-rate {
        height: auto;
      }
    }
  }
  &__text {
    margin-left: 12px;
    line-height: 20px;
  }
  &__nav {
    margin-left: 28px;
    font-size: 20px;
    a {
      cursor: pointer;
      &.disabled {
        cursor: not-allowed;
        color: #ccc;
      }
      &:last-child {
        margin-left: 5px;
      }
    }
  }
  &__card {
    background: #ffffff;
    box-shadow: 0px 1px 9px 0px #eeeeee;
    border-radius: 5px;
    height: 100%;
  }
  // 走马灯布局
  &__carousel {
    margin-top: 58px;
    padding-top: 10px;
    padding-bottom: 10px;
    overflow-y: hidden;
    .card-swiper {
      &__card {
        display: flex;
        flex-direction: column;
        ::v-deep {
          .comment-card {
            &__content {
              flex: 1;
            }
          }
        }
      }
    }
    &::v-deep {
      &.el-carousel {
        // 卡片模式
        &--card {
          margin-left: -8.9%;
          margin-right: -8.9%;
          .el-carousel {
            &__item {
              padding-left: 8.9%;
              padding-right: 8.9%;
              overflow: visible;
              &.is-active {
                padding: 0;
                width: calc(50% - (8.9% * 2));
                margin-left: 8.9%;
                margin-right: 8.9%;
              }
            }
            &__container {
              // 计算卡片的高度
              // 评论图片高度是动态的，图片高度 = （卡片宽度 - 图片marging - 卡片padding）/ 图片数
              // 此处吐槽UI
              height: calc(
                292px + ((var(--card-width) - ((var(--card-img-limit) - 1) * 14px) - 48px) / var(--card-img-limit))
              );
              transition: all 0.1s;
            }
          }
        }
      }
    }
  }
  // 两个布局
  &__row-2 {
    margin-top: 68px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-left: -15px;
    margin-right: -15px;
    .card-swiper {
      &__card {
        cursor: pointer;
        width: 448px;
        height: 100%;
        display: flex;
        flex-direction: column;
        ::v-deep {
          .comment-card {
            &__content {
              flex: 1;
            }
          }
        }
      }
    }
  }
  &__col-2 {
    padding-left: 15px;
    padding-right: 15px;
  }
  // 按钮
  &__btn-wrapper {
    margin-top: 60px;
    text-align: center;
  }

  @media screen and (max-width: 767px) {
    &__carousel {
      margin-left: -10px;
      margin-right: -10px;
      margin-top: 12px;
      padding-top: 10px;
      padding-bottom: 10px;
      overflow-y: hidden;
      .card-swiper {
        &__item {
          padding-left: 10px;
          padding-right: 10px;
          overflow: visible;
        }
      }
      ::v-deep {
        .el-carousel {
          &__container {
            // 计算卡片的高度
            // 评论图片高度是动态的，图片高度 = （卡片宽度 - 图片marging - 卡片padding）/ 图片数
            // 此处吐槽UI
            height: calc(
              242px + ((var(--card-width) - ((var(--card-img-limit) - 1) * 14px) - 24px) / var(--card-img-limit))
            );
            transition: all 0.1s;
          }
        }
      }
    }
    &__header {
      &--left {
        display: block;
      }
      &--center {
        .card-swiper {
          &__rating {
            margin-top: 8;
          }
        }
      }
      .card-swiper {
        &__rating {
          margin-top: 8;
        }
        &__nav {
          flex: 1;
          text-align: right;
        }
      }
    }
    &__nav {
      a {
        &:last-child {
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
